import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, withKeys as _withKeys, Teleport as _Teleport, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/app/ui/assets/svg/ics_o_close.svg'
import _imports_1 from '@/app/ui/assets/svg/chevron-down.svg'
import _imports_2 from '@/app/ui/assets/svg/ics_o_search.svg'
import _imports_3 from '@/app/ui/assets/svg/x-gray.svg'
import _imports_4 from '@/app/ui/assets/svg/ill_spot_search.svg'
import _imports_5 from '@/app/ui/assets/svg/chevron-up-light.svg'


const _hoisted_1 = { class: "flex items-center justify-between" }
const _hoisted_2 = { class: "text-xl font-semibold text-gray-lp-300" }
const _hoisted_3 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_4 = { class: "flex items-start gap-2" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "text-14px text-black-lp-100" }, "Filter", -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  class: "text-gray-lp-600 opacity-60  w-4 h-4"
}, null, -1)
const _hoisted_7 = { class: "relative flex-1" }
const _hoisted_8 = /*#__PURE__*/_createVNode("img", {
  class: "absolute top-4 right-4",
  src: _imports_2,
  alt: ""
}, null, -1)
const _hoisted_9 = {
  key: 0,
  class: "flex items-center gap-2 text-sm text-gray-lp-300"
}
const _hoisted_10 = /*#__PURE__*/_createVNode("img", {
  src: _imports_3,
  alt: ""
}, null, -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("img", {
  src: _imports_3,
  alt: ""
}, null, -1)
const _hoisted_12 = {
  key: 1,
  "data-testid": "booking-v4-client-list-loading",
  class: "flex flex-col gap-2"
}
const _hoisted_13 = {
  key: 2,
  "data-testid": "booking-v4-client-list-error",
  class: "flex flex-col items-center justify-center gap-3 py-8"
}
const _hoisted_14 = { class: "text-sm text-gray-lp-300" }
const _hoisted_15 = /*#__PURE__*/_createVNode("img", {
  src: _imports_4,
  alt: "",
  style: {"width":"160px","height":"136px"}
}, null, -1)
const _hoisted_16 = { class: "text-sm text-gray-lp-300" }
const _hoisted_17 = { class: "w-full text-sm text-left text-gray-lp-300" }
const _hoisted_18 = { class: "sticky top-0 bg-white" }
const _hoisted_19 = { class: "border-b border-gray-lp-1400" }
const _hoisted_20 = { class: "p-2" }
const _hoisted_21 = { class: "p-2" }
const _hoisted_22 = { class: "p-2" }
const _hoisted_23 = { class: "p-2" }
const _hoisted_24 = { class: "p-2" }
const _hoisted_25 = { class: "p-2" }
const _hoisted_26 = { class: "p-2" }
const _hoisted_27 = { class: "p-2" }
const _hoisted_28 = { class: "p-2" }
const _hoisted_29 = { class: "p-2" }
const _hoisted_30 = { class: "p-2" }
const _hoisted_31 = { class: "p-2" }
const _hoisted_32 = {
  key: 0,
  "data-testid": "booking-v4-client-list-loading-more",
  class: "py-2"
}
const _hoisted_33 = { class: "w-full text-gray-lp-300" }
const _hoisted_34 = { class: "flex flex-row justify-between items-center border-b border-gray-lp-400 px-4 py-2" }
const _hoisted_35 = /*#__PURE__*/_createVNode("img", {
  src: _imports_5,
  class: "w-4 h-4"
}, null, -1)
const _hoisted_36 = {
  class: "px-4 py-2 border-b border-gray-lp-400",
  "data-testid": "booking-v4-client-list-select-origin"
}
const _hoisted_37 = {
  class: "px-4 py-2",
  style: {"height":"81px"},
  "data-testid": "booking-v4-client-list-select-service-type"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LpInput = _resolveComponent("LpInput")!
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_SelectSearch = _resolveComponent("SelectSearch")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_MultipleSelectSearch = _resolveComponent("MultipleSelectSearch")!
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_Teleport, { to: "#app > div:nth-child(1)" }, [
      (_ctx.visible)
        ? (_openBlock(), _createBlock("div", {
            key: 0,
            ref: "dialog",
            class: "fixed inset-0 flex items-center justify-center",
            style: {"z-index":"99999999","background":"rgba(0, 0, 0, 0.5)"},
            onMousedown: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)), ["self"])),
            onKeydown: _cache[8] || (_cache[8] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)), ["prevent"]), ["esc"]))
          }, [
            _createVNode("section", {
              role: "dialog",
              "aria-modal": "true",
              "aria-label": _ctx.$t('bookingV4.client.list.title'),
              "data-testid": "booking-v4-client-list-modal",
              class: "bg-white rounded-lg p-4 flex flex-col gap-3",
              style: {"width":"1030px","max-width":"calc(100vw - 40px)","max-height":"436px"}
            }, [
              _createVNode("header", _hoisted_1, [
                _createVNode("h2", _hoisted_2, _toDisplayString(_ctx.$t("bookingV4.client.list.title")), 1),
                _createVNode("button", {
                  type: "button",
                  "data-testid": "booking-v4-client-list-button-close",
                  "aria-label": _ctx.$t('bookingV4.client.list.close'),
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
                }, [
                  _hoisted_3
                ], 8, ["aria-label"])
              ]),
              _createVNode("div", _hoisted_4, [
                _createVNode("button", {
                  id: "filter-client-btn",
                  class: ["flex flex-row items-center gap-2 p-4 py-2.5 rounded-md w-auto flex-shrink-0", [_ctx.isFilterOpen ? 'border-gray-lp-600' : '', 'border']],
                  style: {"min-width":"95px"},
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.openFilter && _ctx.openFilter(...args))),
                  ref: "filterClientButton"
                }, [
                  _hoisted_5,
                  _hoisted_6
                ], 2),
                _createVNode("div", _hoisted_7, [
                  _createVNode(_component_LpInput, {
                    ref: "searchInput",
                    id: "filter-client-input-search",
                    marginVertical: "my-0",
                    "data-testid": "booking-v4-client-list-input-search",
                    "model-value": _ctx.searchKeyword,
                    placeholder: _ctx.$t('bookingV4.client.searchPlaceholder'),
                    "onUpdate:modelValue": _ctx.updateSearch
                  }, {
                    suffix: _withCtx(() => [
                      _hoisted_8
                    ]),
                    _: 1
                  }, 8, ["model-value", "placeholder", "onUpdate:modelValue"])
                ])
              ]),
              (_ctx.hasActiveFilters)
                ? (_openBlock(), _createBlock("div", _hoisted_9, [
                    (_ctx.selectedOrigin && _ctx.selectedOrigin.value)
                      ? (_openBlock(), _createBlock("div", {
                          key: 0,
                          "data-testid": 
              `booking-v4-client-list-filter-chip-${_ctx.selectedOrigin.value}`
            ,
                          class: "flex items-center gap-2 rounded bg-gray-lp-200 px-2 py-1"
                        }, [
                          _createVNode("span", null, _toDisplayString(_ctx.selectedOrigin.label), 1),
                          _createVNode("button", {
                            type: "button",
                            "data-testid": 
                `booking-v4-client-list-filter-chip-clear-${_ctx.selectedOrigin.value}`
              ,
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.updateOrigin(null)))
                          }, [
                            _hoisted_10
                          ], 8, ["data-testid"])
                        ], 8, ["data-testid"]))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.selectedServiceTypes, (serviceType) => {
                      return (_openBlock(), _createBlock("div", {
                        key: serviceType.value,
                        "data-testid": 
              `booking-v4-client-list-filter-chip-${serviceType.value}`
            ,
                        class: "flex items-center gap-2 rounded bg-gray-lp-200 px-2 py-1"
                      }, [
                        _createVNode("span", null, _toDisplayString(serviceType.label), 1),
                        _createVNode("button", {
                          type: "button",
                          "data-testid": 
                `booking-v4-client-list-filter-chip-clear-${serviceType.value}`
              ,
                          onClick: ($event: any) => (_ctx.removeServiceType(serviceType.value))
                        }, [
                          _hoisted_11
                        ], 8, ["data-testid", "onClick"])
                      ], 8, ["data-testid"]))
                    }), 128)),
                    _createVNode("button", {
                      type: "button",
                      "data-testid": "booking-v4-client-list-button-reset",
                      class: "text-red-lp-100 font-semibold",
                      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.resetFilters && _ctx.resetFilters(...args)))
                    }, _toDisplayString(_ctx.$t("bookingV4.client.reset")), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.isInitialLoading)
                ? (_openBlock(), _createBlock("div", _hoisted_12, [
                    (_openBlock(), _createBlock(_Fragment, null, _renderList(6, (index) => {
                      return _createVNode(_component_Skeleton, {
                        key: index,
                        height: "32px"
                      })
                    }), 64))
                  ]))
                : (_ctx.listErrorMessage)
                  ? (_openBlock(), _createBlock("div", _hoisted_13, [
                      _createVNode("p", _hoisted_14, _toDisplayString(_ctx.listErrorMessage), 1),
                      _createVNode(_component_LpButton, {
                        "data-testid": "booking-v4-client-list-button-retry",
                        title: _ctx.$t('bookingV4.client.retry'),
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('retry')))
                      }, null, 8, ["title"])
                    ]))
                  : (!_ctx.clients.length)
                    ? (_openBlock(), _createBlock("div", {
                        key: 3,
                        "data-testid": _ctx.emptyStateTestId,
                        class: "flex flex-col items-center justify-center gap-3 py-8"
                      }, [
                        _hoisted_15,
                        _createVNode("p", _hoisted_16, _toDisplayString(_ctx.emptyStateMessage), 1)
                      ], 8, ["data-testid"]))
                    : (_openBlock(), _createBlock("div", {
                        key: 4,
                        class: "bg-white overflow-auto highlight-container",
                        onScrollPassive: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.onScroll && _ctx.onScroll(...args)))
                      }, [
                        _createVNode("table", _hoisted_17, [
                          _createVNode("thead", _hoisted_18, [
                            _createVNode("tr", _hoisted_19, [
                              _createVNode("th", _hoisted_20, _toDisplayString(_ctx.$t("bookingV4.client.list.clientName")), 1),
                              _createVNode("th", _hoisted_21, _toDisplayString(_ctx.$t("bookingV4.client.list.clientAlias")), 1),
                              _createVNode("th", _hoisted_22, _toDisplayString(_ctx.$t("bookingV4.client.list.clientOrigin")), 1),
                              _createVNode("th", _hoisted_23, _toDisplayString(_ctx.$t("bookingV4.client.list.clientType")), 1),
                              _createVNode("th", _hoisted_24, _toDisplayString(_ctx.$t("bookingV4.client.list.serviceType")), 1),
                              _createVNode("th", _hoisted_25, _toDisplayString(_ctx.$t("bookingV4.client.list.clientCode")), 1)
                            ])
                          ]),
                          _createVNode("tbody", null, [
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.clients, (client) => {
                              return (_openBlock(), _createBlock("tr", {
                                key: client.clientCode,
                                "data-testid": `booking-v4-client-list-row-${client.clientCode}`,
                                class: [
                  'cursor-pointer',
                  _ctx.highlightedClientCode === client.clientCode
                    ? 'bg-gray-lp-200'
                    : ''
                ],
                                onMousedown: ($event: any) => (_ctx.selectClient(client))
                              }, [
                                _createVNode("td", _hoisted_26, _toDisplayString(client.clientName), 1),
                                _createVNode("td", _hoisted_27, _toDisplayString(client.clientAlias), 1),
                                _createVNode("td", _hoisted_28, _toDisplayString(client.clientOriginCity), 1),
                                _createVNode("td", _hoisted_29, _toDisplayString(client.clientCategory), 1),
                                _createVNode("td", _hoisted_30, _toDisplayString(client.clientPackageType), 1),
                                _createVNode("td", _hoisted_31, _toDisplayString(client.clientCode), 1)
                              ], 42, ["data-testid", "onMousedown"]))
                            }), 128))
                          ])
                        ]),
                        (_ctx.isLoadingMore)
                          ? (_openBlock(), _createBlock("div", _hoisted_32, [
                              _createVNode(_component_Skeleton, { height: "32px" })
                            ]))
                          : _createCommentVNode("", true)
                      ], 32))
            ], 8, ["aria-label"])
          ], 544))
        : _createCommentVNode("", true)
    ])),
    _createVNode(_component_OverlayPanel, {
      ref: "op",
      style: _ctx.tooltipStyle,
      class: "client-filter-op",
      id: "client-filter-op"
    }, {
      default: _withCtx(() => [
        _createVNode("section", _hoisted_33, [
          _createVNode("div", _hoisted_34, [
            _createTextVNode(_toDisplayString(_ctx.$t("bookingV4.client.filter.title")) + " ", 1),
            _hoisted_35
          ]),
          _createVNode("div", _hoisted_36, [
            _createVNode("div", {
              "data-testid": 
            _ctx.origins.length === 0
              ? 'booking-v4-client-list-origin-not-found'
              : undefined
          
            }, [
              _createVNode(_component_DataWrapper, {
                id: "filter-client-select-wrapper",
                label: _ctx.$t('bookingV4.client.filter.originLabel')
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_SelectSearch, {
                    "model-value": _ctx.selectedOrigin,
                    options: _ctx.origins,
                    keyName: "label",
                    keyValue: "value",
                    isLoading: _ctx.isOriginLoading,
                    useInfiniteScroll: "",
                    maxHeight: "214px",
                    placeholder: _ctx.$t('bookingV4.client.originPlaceholder'),
                    errorMessage: _ctx.$t('bookingV4.client.originNotFound'),
                    "onUpdate:modelValue": _ctx.updateOrigin,
                    onFocus: _ctx.onOriginFocus,
                    onFilter: _ctx.onOriginFilter,
                    onScrolled: _ctx.onOriginScrolled,
                    onEsc: _ctx.onEscFilter
                  }, null, 8, ["model-value", "options", "isLoading", "placeholder", "errorMessage", "onUpdate:modelValue", "onFocus", "onFilter", "onScrolled", "onEsc"])
                ]),
                _: 1
              }, 8, ["label"])
            ], 8, ["data-testid"])
          ]),
          _createVNode("div", _hoisted_37, [
            _createVNode(_component_DataWrapper, {
              id: "filter-client-select-wrapper",
              label: _ctx.$t('bookingV4.client.filter.serviceTypeLabel')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_MultipleSelectSearch, {
                  "model-value": _ctx.selectedServiceTypes,
                  options: _ctx.serviceTypeOptions,
                  keyName: "label",
                  keyValue: "value",
                  placeholder: _ctx.$t('bookingV4.client.serviceTypePlaceholder'),
                  onChange: _ctx.updateServiceTypes
                }, null, 8, ["model-value", "options", "placeholder", "onChange"])
              ]),
              _: 1
            }, 8, ["label"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["style"])
  ], 64))
}